import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import deleteIcon from 'images/deleteIcon.svg';
import { inject, observer } from 'mobx-react';

@inject('topicsStore')
@observer
class ControllButtons extends PureComponent {
  render() {
    const {topicsStore, saveTopic, openDeleteConfirmModal} = this.props;
    return (
      <div className="row">
        <div className="container">
          <div className="row edit-controlls">
            {(topicsStore.topic && topicsStore.topic.id && topicsStore.topic.id !== 1) && (
              <div className="col-auto">
                <button onClick={openDeleteConfirmModal} className='delete text'>delete topic</button>
                <button className='delete small'><img src={deleteIcon} alt="delete"/></button>
              </div>
            )}
            <div className="col-auto ml-a">
              <Link className='create' to='/'>cancel</Link>
              <button className='create' onClick={saveTopic}>{topicsStore.topic.id ? 'edit topic' : 'create topic'}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ControllButtons;


// WEBPACK FOOTER //
// ./src/modules/topic/components/ControllButtons.js